import { GoogleTagAnalyticsService } from '@/app/services/google-tag';
import { RouteValidatorService } from '@/app/services/route-validator.service';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  inject,
  SimpleChanges,
} from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { environment } from '../../../environments/environment';
import { BreadcrumbsComponent } from '../../components/shared/breadcrumbs/breadcrumbs.component';
import { TabBarComponent } from '../../components/shared/tab-bar/tab-bar.component';
import { LocalStorageService } from '../../services/localstorage.service';
import { ScoresSportsService } from '../../services/scores-sports.service';
import { SportsService } from '../../services/sport.service';
import { TeamsFavoritesService } from '../../services/teams-favorites.service';
import { LastesMatchesComponent } from '../competition-details/components/lastes-matches/lastes-matches.component';
import { NextMatchesComponent } from '../competition-details/components/next-matches/next-matches.component';
import { TodayMatchesComponent } from '../competition-details/components/today-matches/today-matches.component';
import { StandingsFootballComponent } from '../match-details/components/standings-football/standings-football.component';
import { StandingsSportsComponent } from '../match-details/components/standings-sports/standings-sports.component';
import { ParamsModel } from '../match-details/models/params.model';
import { EquipmentsComponent } from './components/equipments/equipments.component';

@Component({
  selector: 'app-team-details',
  standalone: true,
  imports: [
    BreadcrumbsComponent,
    NzSkeletonComponent,
    CommonModule,
    TodayMatchesComponent,
    NextMatchesComponent,
    LastesMatchesComponent,
    StandingsFootballComponent,
    StandingsSportsComponent,
    TabBarComponent,
    TranslateModule,
    EquipmentsComponent,
  ],
  templateUrl: './team-details.component.html',
  styleUrl: './team-details.component.scss',
})
export class TeamDetailsComponent {
  private routeValidatorService = inject(RouteValidatorService);
  private googleTagAnalyticsService = inject(GoogleTagAnalyticsService);

  loader = true;
  loaderMatches = true;

  urlSVG = environment.urlIcon;
  urlIMG = environment.urlIMG;
  urlMatch: boolean = false;

  myTeamsList = this.lsService.getFavoriteFromLocal('TEAM');

  teamInfo: any = {};

  selectedIndex: number = 0;

  optionsMenu = [
    this.translateService.instant('Matches'),
    this.translateService.instant('Scores'),
    this.translateService.instant('Standing'),
    this.translateService.instant('Team'),
  ];

  constructor(
    private readonly lsService: LocalStorageService,
    private ref: ChangeDetectorRef,
    private readonly router: Router,
    private readonly _activateRoute: ActivatedRoute,
    private translateService: TranslateService,
    public scoresServices: ScoresSportsService,
    private teamService: TeamsFavoritesService,
    public readonly sportsServices: SportsService
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.urlMatch = event.url.includes('/partido/');
      }
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    this._activateRoute.params.subscribe((params: any) => {
      if (params) this.getTeamInfo(params);
      else this.router.navigate(['/scores/Futbol']);
    });
  }

  ngOnInit(): void {
    const selectedSport = this.sportsServices.getSelectedSport();
    console.log({ selectedSport });
    if (this.sportsServices.getSelectedSport() === 'Futbol') {
      console.log('object');
      this.router.navigate(['/']);
      return;
    }

    this.router.navigate([this.routeValidatorService.currentUrl()], {
      replaceUrl: true,
      queryParamsHandling: 'preserve',
    });

    this.lsService.changeTeamFavorites.subscribe((updatedList) => {
      this.myTeamsList = updatedList;
      this.teamInfo.favorite =
        this.myTeamsList.find(
          (elem: any) => elem.idTeam === this.teamInfo.id
        ) != null;
    });

    this._activateRoute.params.subscribe((params: any) => {
      if (params) this.getTeamInfo(params);
      else this.router.navigate(['/scores/Futbol']);
    });
  }

  private getTeamInfo(params: ParamsModel) {
    this.teamInfo = {};
    this.scoresServices.dashboardScores = [];
    this.loader = true;
    this.loaderMatches = true;
    this.teamService
      .getTeamInfoById(params.idTeam, params.idCompetition)
      .subscribe(
        (response: any) => {
          if (response.status) {
            // google analytics
            this.googleTagAnalyticsService.event('view_team', {
              ...response.team,
            });

            this.teamInfo = response.team;
            // TODO: delete favorito
            // const teamsCompetition: any = this.myTeamsList;
            // this.teamInfo.favorite =
            //   teamsCompetition.length === 0
            //     ? false
            //     : teamsCompetition.find(
            //         (elem: any) => elem.idTeam === this.teamInfo.id
            //       ) != null;
            setTimeout(() => {
              this.loader = false;
            }, 500);
          } else this.loader = false;
        },
        () => {
          this.loader = false;
        }
      );
  }

  // TODO: delete favorito
  // markTeamFavorite(team: any) {
  //   if (
  //     this.lsService.setFavoritesTeam({
  //       idTeam: team.id,
  //       national: team.national,
  //       logoCountry: team.country_logo,
  //       logo: team.logo,
  //       nameEs: team.nameEs,
  //       nameEn: team.nameEn,
  //       countryEs: '',
  //       countryEn: '',
  //       country: team.country,
  //     })
  //   ) {
  //     team.favorite = !team.favorite;
  //     this.ref.markForCheck();
  //   }
  // }

  menuSelected(event: number) {
    this.selectedIndex = event;
  }
}
